import { render, staticRenderFns } from "./ChatRecord.vue?vue&type=template&id=71fef438&scoped=true&"
import script from "./ChatRecord.vue?vue&type=script&lang=js&"
export * from "./ChatRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChatRecord.vue?vue&type=style&index=0&id=71fef438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fef438",
  null
  
)

export default component.exports